/**
 * Splash screen — first 2.6s of cold start on mobile builds (v1.0).
 *
 * Uses the AI-generated /brand/splash-2048.png as the hero artwork. We layer
 * a CSS progress bar + "Getting things moving…" caption on top so the
 * branding is identical to the approved splash mockup.
 *
 * Pure presentational + setTimeout for unmount. No data fetching.
 */

import { useEffect, useState } from "react";

export default function MobileSplash({ durationMs = 2600 }) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), durationMs);
    return () => clearTimeout(t);
  }, [durationMs]);
  if (done) return null;
  return (
    <div className="t247-splash t247-splash-hero" data-testid="mobile-splash">
      <img
        src="/brand/splash-2048.png"
        alt="Transport Anything 247"
        className="t247-splash-hero-img"
      />
      <div className="t247-splash-overlay" />
      <div className="t247-splash-label">Getting things moving…</div>
      <div className="t247-splash-progress" aria-hidden>
        <span />
      </div>
    </div>
  );
}
